import { render } from "./PCMCost.vue?vue&type=template&id=52fbe2d7&scoped=true"
import script from "./PCMCost.vue?vue&type=script&lang=js"
export * from "./PCMCost.vue?vue&type=script&lang=js"

import "./PCMCost.vue?vue&type=style&index=0&id=52fbe2d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52fbe2d7"]])

export default __exports__